/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_Feature3Inputs */

const en_st_mock_feature3 = /** @type {(inputs: St_Mock_Feature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR check-in`)
};

const id_st_mock_feature3 = /** @type {(inputs: St_Mock_Feature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in QR`)
};

/**
* | output |
* | --- |
* | "QR check-in" |
*
* @param {St_Mock_Feature3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_feature3 = /** @type {((inputs?: St_Mock_Feature3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_Feature3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_feature3(inputs)
	return en_st_mock_feature3(inputs)
});